export default {
  metricTabsWithMetrics: undefined,
};
